import React, { useEffect, useState, useRef } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { BookOpen, Users, Briefcase, Music, ArrowRight, CheckCircle2, Calendar, Recycle, X, Loader2, GraduationCap, Award, Sparkles, Building2, Handshake, UserPlus, PartyPopper, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { saveSubmission } from '../services/databaseService';
import { sendViaWeb3Forms } from '../services/web3formsService';
type ModalType = 'ateliers' | 'festival' | 'employeur' | 'recruter' | 'partenariat' | 'recyclage' | null;
export function ActionsPage() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formationAutre, setFormationAutre] = useState('');
  const [showFormationAutre, setShowFormationAutre] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);
  // Auto-open ateliers modal if URL contains #inscription
  useEffect(() => {
    if (window.location.hash === '#inscription') {
      setActiveModal('ateliers');
      // Clean the hash without page reload
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData(formRef.current!);
    const data: Record<string, any> = {};
    formData.forEach((value, key) => {
      if (data[key]) {
        // Handle multiple values (checkboxes)
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });
    // Map form data to submission types
    let submission: any = {
      type: ''
    };
    switch (activeModal) {
      case 'ateliers':
        submission = {
          type: 'atelier',
          nom: data.nom || '',
          prenom: data.prenom || '',
          dateNaissance: data.dateNaissance || '',
          sexe: data.sexe || '',
          situation: data.situation || '',
          niveauEtudes: data.niveauEtudes || '',
          ville: data.ville || '',
          quartier: data.quartier || '',
          telephone: data.telephone || '',
          email: data.email || '',
          formationSouhaitee: data.formationSouhaitee || '',
          formationAutre: formationAutre || '',
          source: data.source || '',
          motivations: data.motivations || ''
        };
        break;
      case 'festival':
        submission = {
          type: 'festival',
          nom: data.nom || '',
          prenom: data.prenom || '',
          telephone: data.telephone || '',
          email: data.email || '',
          profil: data.profil || '',
          participation: data.participation || '',
          message: data.message || ''
        };
        break;
      case 'employeur':
        submission = {
          type: 'employeur',
          nom: data.nom || '',
          prenom: data.prenom || '',
          typeEmployeur: data.typeEmployeur || '',
          ville: data.ville || '',
          telephone: data.telephone || '',
          email: data.email || '',
          profilsRecherches: data.profilsRecherches || '',
          attentes: data.attentes || ''
        };
        break;
      case 'recruter':
        submission = {
          type: 'recruter',
          nom: data.nom || '',
          prenom: data.prenom || '',
          telephone: data.telephone || '',
          email: data.email || '',
          ville: data.ville || '',
          quartier: data.quartier || '',
          typePersonnel: data.typePersonnel || '',
          typeContrat: data.typeContrat || '',
          dateDebut: data.dateDebut || '',
          description: data.description || ''
        };
        break;
      case 'partenariat':
        submission = {
          type: 'partenariat',
          organisation: data.organisation || '',
          typeOrganisation: data.typeOrganisation || '',
          nomContact: data.nomContact || '',
          fonction: data.fonction || '',
          telephone: data.telephone || '',
          email: data.email || '',
          typePartenariat: data.typePartenariat || '',
          proposition: data.proposition || ''
        };
        break;
      case 'recyclage':
        // Collect checked points
        const pointsFormation: string[] = [];
        document.querySelectorAll('input[name="pointsFormation"]:checked').forEach(el => {
          pointsFormation.push((el as HTMLInputElement).value);
        });
        submission = {
          type: 'recyclage',
          nomEmployeur: data.nomEmployeur || '',
          telephoneEmployeur: data.telephoneEmployeur || '',
          emailEmployeur: data.emailEmployeur || '',
          villeEmployeur: data.villeEmployeur || '',
          nomEmploye: data.nomEmploye || '',
          posteActuel: data.posteActuel || '',
          anciennete: data.anciennete || '',
          telephoneEmploye: data.telephoneEmploye || '',
          pointsFormation: pointsFormation,
          autresPoints: data.autresPoints || '',
          periodeSouhaitee: data.periodeSouhaitee || '',
          dureeSouhaitee: data.dureeSouhaitee || '',
          observations: data.observations || ''
        };
        break;
    }
    try {
      // Sauvegarder localement
      saveSubmission(submission);
      // Collecter les champs pour Web3Forms
      const fields: Record<string, string> = {};
      formData.forEach((value, key) => {
        if (typeof value === 'string') {
          fields[key] = value;
        }
      });
      if (formationAutre) {
        fields['formationAutre'] = formationAutre;
      }
      // Envoyer via Web3Forms
      const web3Result = await sendViaWeb3Forms({
        type: activeModal!,
        fields
      });
      console.log('📧 Web3Forms result:', web3Result);
      setIsSubmitting(false);
      setIsSuccess(true);
    } catch (error) {
      console.error('Error saving submission:', error);
      setIsSubmitting(false);
      setIsSuccess(true); // Montrer succès quand même (sauvegardé localement)
    }
  };
  const closeModal = () => {
    setActiveModal(null);
    setIsSuccess(false);
    setShowFormationAutre(false);
    setFormationAutre('');
  };
  const handleFormationChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setShowFormationAutre(e.target.value === 'autre');
  };
  const inputClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all';
  const selectClass = 'w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#1E88E5] focus:border-transparent outline-none transition-all bg-white';
  const labelClass = 'text-sm font-medium text-gray-700';
  const modalConfigs = {
    ateliers: {
      title: 'Inscription aux Ateliers',
      subtitle: 'Mars 2026 - Remplissez ce formulaire pour candidater',
      successMessage: 'Candidature envoyée ! Notre équipe examinera votre profil et vous contactera très prochainement.'
    },
    festival: {
      title: 'Participation au Festival',
      subtitle: 'Juin 2026 - Inscrivez-vous pour participer au Festival des Personnels de Maison',
      successMessage: "Inscription enregistrée ! Vous recevrez bientôt les détails de l'événement."
    },
    employeur: {
      title: 'Devenir Employeur Partenaire',
      subtitle: "Rejoignez notre réseau d'employeurs engagés pour un emploi digne",
      successMessage: 'Demande envoyée ! Notre équipe vous contactera pour finaliser votre adhésion.'
    },
    recruter: {
      title: 'Recruter un Personnel Formé',
      subtitle: 'Décrivez vos besoins et nous vous mettrons en relation avec des profils qualifiés',
      successMessage: 'Demande reçue ! Nous vous proposerons des profils correspondant à vos critères.'
    },
    partenariat: {
      title: 'Proposer un Partenariat',
      subtitle: "Collaborons ensemble pour l'insertion professionnelle digne",
      successMessage: 'Proposition reçue ! Notre équipe étudiera votre demande et vous recontactera.'
    },
    recyclage: {
      title: 'Recycler mon Employé',
      subtitle: 'Offrez une formation de mise à niveau à votre personnel',
      successMessage: 'Demande enregistrée ! Nous vous contacterons pour organiser la formation.'
    }
  };
  return <Layout data-id="element-207">
      <SEO {...pageSEO.actions} data-id="element-208" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-209">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-210">
          <h1 className="text-4xl font-bold mb-4" data-id="element-211">Nos Actions</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-212">
            Les actions de l'ADCC s'articulent autour de quatre piliers
            complémentaires : la formation professionnelle, la valorisation
            sociale et culturelle, le placement et l'insertion professionnelle,
            et le recyclage des compétences.
          </p>
        </div>
      </div>

      {/* Four Pillars Introduction */}
      <section className="py-16 bg-white" data-id="element-213">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-215">
            {[{
            icon: BookOpen,
            title: 'Formation Professionnelle',
            desc: 'Acquisition de compétences techniques certifiantes'
          }, {
            icon: Users,
            title: 'Valorisation Sociale',
            desc: 'Reconnaissance et dignité des métiers de service'
          }, {
            icon: Briefcase,
            title: 'Placement & Insertion',
            desc: 'Accompagnement vers un emploi durable'
          }, {
            icon: Recycle,
            title: 'Recyclage',
            desc: 'Reconversion et mise à jour des compétences'
          }].map((pillar, index) => <Card key={index} className="text-center border-t-4 border-t-[#1E88E5] hover:shadow-lg transition-shadow duration-300" data-id="element-216">
                <CardContent className="pt-8 pb-6" data-id="element-217">
                  <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-4" data-id="element-218">
                    <pillar.icon className="w-8 h-8 text-[#1E88E5]" data-id="element-219" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-220">
                    {pillar.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-221">{pillar.desc}</p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Ateliers de Formation - Mars 2026 */}
      <section className="py-20 bg-gray-50" data-id="element-222">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
          <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-224">
            <div className="w-full lg:w-1/2" data-id="element-225">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl min-h-[450px] bg-gradient-to-br from-[#1E88E5] via-[#2C3E50] to-[#1976D2] flex flex-col items-center justify-center text-center p-8 group" data-id="element-226">
                <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-227"></div>
                <div className="absolute top-10 left-10 animate-bounce delay-100 opacity-20" data-id="element-228">
                  <GraduationCap className="w-16 h-16 text-white" data-id="element-229" />
                </div>
                <div className="absolute bottom-10 right-10 animate-bounce delay-300 opacity-20" data-id="element-230">
                  <Award className="w-16 h-16 text-white" data-id="element-231" />
                </div>
                <div className="absolute top-1/2 right-8 animate-pulse opacity-20" data-id="element-232">
                  <Sparkles className="w-12 h-12 text-yellow-300" data-id="element-233" />
                </div>
                <div className="relative z-10 transform transition-transform duration-500 group-hover:scale-105" data-id="element-234">
                  <div className="inline-block bg-white/20 backdrop-blur-md border border-white/30 rounded-full px-6 py-2 mb-6 shadow-lg" data-id="element-235">
                    <span className="flex items-center gap-2 text-white font-bold tracking-wider" data-id="element-236">
                      <span className="relative flex h-3 w-3" data-id="element-237">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-238"></span>
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-239"></span>
                      </span>
                      PLACES LIMITÉES
                    </span>
                  </div>
                  <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-2 tracking-tight drop-shadow-lg" data-id="element-240">
                    MARS 2026
                  </h2>
                  <div className="h-1 w-24 bg-yellow-400 mx-auto mb-6 rounded-full" data-id="element-241"></div>
                  <h3 className="text-2xl md:text-3xl font-bold text-blue-100 mb-8" data-id="element-242">
                    Transformez votre avenir
                  </h3>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20 inline-block" data-id="element-243">
                    <p className="text-white font-medium" data-id="element-244">Session Intensive</p>
                    <p className="text-sm text-blue-200" data-id="element-245">
                      Entretien & Maintenance
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/2" data-id="element-246">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-247">
                Formation Professionnelle
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-2" data-id="element-248">
                Ateliers de Formation – Mars 2026
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-249">
                Programme intensif de formation aux métiers de l'entretien et de
                la maintenance, incluant des modules théoriques et pratiques
                pour une professionnalisation complète.
              </p>

              <div className="bg-[#1E88E5]/10 border-l-4 border-[#1E88E5] p-4 mb-6" data-id="element-250">
                <p className="font-semibold text-gray-900 mb-2" data-id="element-251">
                  Nouveauté : Dispositif de placement intégré
                </p>
                <p className="text-gray-700" data-id="element-252">
                  Les participants aux ateliers de mars 2026 pourront intégrer,
                  selon leur profil, le dispositif de placement ADCC.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 mb-6" data-id="element-253">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-254">
                  Programme :
                </h3>
                <div className="space-y-3" data-id="element-255">
                  {["Panels sur les métiers d'entretien et maintenance", 'Pitch CV avec jury', "Introduction aux techniques d'entretien, maintenance et hygiène", 'Compétences relationnelles et communication'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-256">
                      <CheckCircle2 className="w-5 h-5 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-257" />
                      <span className="text-sm text-gray-700" data-id="element-258">{item}</span>
                    </div>)}
                </div>
              </div>

              <Button className="gap-2" onClick={() => setActiveModal('ateliers')} data-id="element-259">
                S'inscrire aux ateliers
                <ArrowRight className="w-4 h-4" data-id="element-260" />
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Festival - Juin 2026 */}
      <section className="py-20 bg-white" data-id="element-261">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
          <div className="flex flex-col lg:flex-row-reverse gap-12 items-center" data-id="element-263">
            <div className="w-full lg:w-1/2" data-id="element-264">
              <div className="relative rounded-2xl overflow-hidden shadow-xl min-h-[400px] bg-purple-100 flex items-center justify-center group" data-id="element-265">
                <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Festival des personnels de maison Juin 2026" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-266" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" data-id="element-267"></div>
                <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-full shadow-md z-10 flex items-center gap-2" data-id="element-268">
                  <Calendar className="w-5 h-5 text-[#1E88E5]" data-id="element-269" />
                  <span className="font-bold text-gray-900" data-id="element-270">Juin 2026</span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/2" data-id="element-271">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-272">
                Valorisation & Networking
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-2" data-id="element-273">
                Festival des Personnels de Maison – Juin 2026
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-274">
                Un événement unique célébrant la dignité et les compétences des
                personnels de maison, combinant valorisation culturelle et
                opportunités professionnelles.
              </p>

              <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 mb-6" data-id="element-275">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-276">
                  Au programme :
                </h3>
                <div className="space-y-3" data-id="element-277">
                  {['Célébrations culturelles et témoignages inspirants', 'Espace de rencontres professionnelles', 'Présentation de profils qualifiés aux employeurs', 'Ateliers de networking et speed-meeting', "Création de passerelles vers l'emploi"].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-278">
                      <Music className="w-5 h-5 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-279" />
                      <span className="text-sm text-gray-700" data-id="element-280">{item}</span>
                    </div>)}
                </div>
              </div>

              <Button variant="secondary" className="gap-2" onClick={() => setActiveModal('festival')} data-id="element-281">
                <PartyPopper className="w-4 h-4" data-id="element-282" />
                Participer au festival
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Placement & Insertion Section */}
      <section className="py-20 bg-gray-50" data-id="element-283">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
          <div className="text-center mb-12" data-id="element-285">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-286">
              Notre Pilier Stratégique
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4" data-id="element-287">
              Placement & Insertion Professionnelle
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-288">
              L'ADCC met en place un dispositif de placement progressif de
              personnels formés, en collaboration avec des familles,
              entreprises, institutions et partenaires.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-289">
            <Card className="bg-white" data-id="element-290">
              <CardContent className="p-8" data-id="element-291">
                <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-292">
                  Ce que nous proposons
                </h3>
                <div className="space-y-4" data-id="element-293">
                  {[{
                  title: 'Identification et préparation des profils formés',
                  desc: 'Évaluation des compétences et matching avec les besoins'
                }, {
                  title: 'Mise en relation avec des employeurs',
                  desc: 'Réseau de familles, entreprises et structures partenaires'
                }, {
                  title: "Sensibilisation aux bonnes pratiques d'emploi",
                  desc: 'Accompagnement des employeurs au respect des droits'
                }, {
                  title: 'Suivi post-placement et médiation si nécessaire',
                  desc: 'Accompagnement continu pour garantir la durabilité'
                }].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-294">
                      <div className="flex-shrink-0 w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center" data-id="element-295">
                        <span className="text-[#1E88E5] font-bold text-sm" data-id="element-296">
                          {index + 1}
                        </span>
                      </div>
                      <div data-id="element-297">
                        <h4 className="font-semibold text-gray-900 mb-1" data-id="element-298">
                          {item.title}
                        </h4>
                        <p className="text-sm text-gray-600" data-id="element-299">{item.desc}</p>
                      </div>
                    </div>)}
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-[#1E88E5] to-[#1976D2] text-white" data-id="element-300">
              <CardContent className="p-8" data-id="element-301">
                <h3 className="text-xl font-bold mb-6" data-id="element-302">Notre Objectif</h3>
                <p className="text-lg text-blue-100 mb-8" data-id="element-303">
                  Créer un cadre structuré, sécurisé et respectueux pour
                  l'emploi des personnels de maison.
                </p>

                <div className="space-y-4" data-id="element-304">
                  {[{
                  title: 'Dignité',
                  desc: 'Respect des droits et de la personne'
                }, {
                  title: 'Transparence',
                  desc: "Clarté sur les conditions d'emploi"
                }, {
                  title: 'Durabilité',
                  desc: 'Insertion professionnelle à long terme'
                }].map((item, index) => <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-305">
                      <div className="flex items-center gap-3 mb-2" data-id="element-306">
                        <CheckCircle2 className="w-6 h-6" data-id="element-307" />
                        <h4 className="font-bold" data-id="element-308">{item.title}</h4>
                      </div>
                      <p className="text-sm text-blue-100" data-id="element-309">{item.desc}</p>
                    </div>)}
                </div>

                <div className="mt-8 space-y-3" data-id="element-310">
                  <Button variant="ghost" className="w-full bg-white text-[#1E88E5] hover:bg-gray-100" onClick={() => setActiveModal('employeur')} data-id="element-311">
                    <Building2 className="w-4 h-4 mr-2" data-id="element-312" />
                    Devenir employeur partenaire
                  </Button>
                  <Button variant="ghost" className="w-full bg-white/20 text-white hover:bg-white/30 border border-white/30" onClick={() => setActiveModal('recyclage')} data-id="element-313">
                    <RefreshCw className="w-4 h-4 mr-2" data-id="element-314" />
                    Recycler mon employé
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 text-center" data-id="element-315">
            <p className="text-2xl font-bold text-gray-900 mb-4" data-id="element-316">
              "Former sans débouché n'est pas suffisant. Notre engagement :
              transformer les compétences en opportunités d'emploi."
            </p>
            <p className="text-gray-600" data-id="element-317">
              Le placement professionnel constitue un indicateur clé de réussite
              de nos programmes.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-white" data-id="element-318">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-319">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-320">
            Rejoignez notre réseau de partenaires
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-321">
            Que vous soyez une famille, une entreprise ou une institution,
            devenez partenaire de l'ADCC pour favoriser l'insertion
            professionnelle digne.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap" data-id="element-322">
            <Button size="lg" className="gap-2" onClick={() => setActiveModal('recruter')} data-id="element-323">
              <UserPlus className="w-5 h-5" data-id="element-324" />
              Recruter un personnel formé
            </Button>
            <Button variant="secondary" size="lg" className="gap-2" onClick={() => setActiveModal('partenariat')} data-id="element-325">
              <Handshake className="w-5 h-5" data-id="element-326" />
              Proposer un partenariat
            </Button>
            <Button variant="secondary" size="lg" className="gap-2" onClick={() => setActiveModal('recyclage')} data-id="element-327">
              <RefreshCw className="w-5 h-5" data-id="element-328" />
              Recycler mon employé
            </Button>
          </div>
        </div>
      </section>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto" data-id="element-329">
          <div className="bg-white rounded-2xl w-full max-w-3xl shadow-2xl my-8 relative max-h-[90vh] overflow-y-auto" data-id="element-330">
            <button onClick={closeModal} className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors z-10" data-id="element-331">
              <X className="w-6 h-6" data-id="element-332" />
            </button>

            <div className="p-8" data-id="element-333">
              <div className="text-center mb-8" data-id="element-334">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-335">
                  {modalConfigs[activeModal].title}
                </h2>
                <p className="text-gray-600 mt-2" data-id="element-336">
                  {modalConfigs[activeModal].subtitle}
                </p>
              </div>

              {isSuccess ? <div className="text-center py-12" data-id="element-337">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-338">
                    <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-339" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-340">
                    Demande envoyée !
                  </h3>
                  <p className="text-gray-600 mb-8" data-id="element-341">
                    {modalConfigs[activeModal].successMessage}
                  </p>
                  <Button onClick={closeModal} data-id="element-342">Fermer</Button>
                </div> : <form ref={formRef} onSubmit={handleSubmit} className="space-y-6" data-id="element-343">
                  {/* Formulaire Ateliers */}
                  {activeModal === 'ateliers' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-344">
                      <div className="space-y-2" data-id="element-345">
                        <label className={labelClass} data-id="element-346">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom de famille" data-id="element-347" />
                      </div>
                      <div className="space-y-2" data-id="element-348">
                        <label className={labelClass} data-id="element-349">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-350" />
                      </div>
                      <div className="space-y-2" data-id="element-351">
                        <label className={labelClass} data-id="element-352">
                          Date de naissance *
                        </label>
                        <input name="dateNaissance" type="date" required className={inputClass} data-id="element-353" />
                      </div>
                      <div className="space-y-2" data-id="element-354">
                        <label className={labelClass} data-id="element-355">Sexe *</label>
                        <select name="sexe" required className={selectClass} data-id="element-356">
                          <option value="" data-id="element-357">Sélectionner...</option>
                          <option value="F" data-id="element-358">Femme</option>
                          <option value="H" data-id="element-359">Homme</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-360">
                        <label className={labelClass} data-id="element-361">
                          Situation professionnelle *
                        </label>
                        <select name="situation" required className={selectClass} data-id="element-362">
                          <option value="" data-id="element-363">Sélectionner...</option>
                          <option value="emploi" data-id="element-364">En emploi</option>
                          <option value="sans_emploi" data-id="element-365">Sans emploi</option>
                          <option value="etudiant" data-id="element-366">Étudiant(e)</option>
                          <option value="autre" data-id="element-367">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-368">
                        <label className={labelClass} data-id="element-369">Niveau d'études</label>
                        <select name="niveauEtudes" className={selectClass} data-id="element-370">
                          <option value="" data-id="element-371">Sélectionner...</option>
                          <option value="sans" data-id="element-372">Sans diplôme</option>
                          <option value="cep" data-id="element-373">CEP</option>
                          <option value="bepc" data-id="element-374">BEPC</option>
                          <option value="bac" data-id="element-375">BAC</option>
                          <option value="licence" data-id="element-376">Licence</option>
                          <option value="master" data-id="element-377">Master</option>
                          <option value="autre" data-id="element-378">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-379">
                        <label className={labelClass} data-id="element-380">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-381" />
                      </div>
                      <div className="space-y-2" data-id="element-382">
                        <label className={labelClass} data-id="element-383">Quartier *</label>
                        <input name="quartier" type="text" required className={inputClass} placeholder="Ex: Haie Vive" data-id="element-384" />
                      </div>
                      <div className="space-y-2" data-id="element-385">
                        <label className={labelClass} data-id="element-386">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-387" />
                      </div>
                      <div className="space-y-2" data-id="element-388">
                        <label className={labelClass} data-id="element-389">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-390" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-391">
                        <label className={labelClass} data-id="element-392">
                          Formation souhaitée
                        </label>
                        <select name="formationSouhaitee" className={selectClass} onChange={handleFormationChange} data-id="element-393">
                          <option value="" data-id="element-394">Sélectionner...</option>
                          <option value="employe_maison" data-id="element-395">
                            Employé(e) de maison
                          </option>
                          <option value="agent_entretien" data-id="element-396">
                            Agent(e) d'entretien en entreprise
                          </option>
                          <option value="femme_chambre" data-id="element-397">
                            Femme de chambre / Valet d'hôtel
                          </option>
                          <option value="serveur" data-id="element-398">
                            Serveur(se) en restauration
                          </option>
                          <option value="garde_enfant" data-id="element-399">Garde d'enfant</option>
                        </select>
                      </div>
                      {showFormationAutre && <div className="space-y-2 md:col-span-2" data-id="element-400">
                          <label className={labelClass} data-id="element-401">
                            Précisez la formation souhaitée *
                          </label>
                          <input type="text" required className={inputClass} placeholder="Décrivez la formation que vous souhaitez suivre" value={formationAutre} onChange={e => setFormationAutre(e.target.value)} data-id="element-402" />
                        </div>}
                      <div className="space-y-2 md:col-span-2" data-id="element-403">
                        <label className={labelClass} data-id="element-404">
                          Comment avez-vous connu l'ADCC ?
                        </label>
                        <select name="source" className={selectClass} data-id="element-405">
                          <option value="" data-id="element-406">Sélectionner...</option>
                          <option value="reseaux" data-id="element-407">Réseaux sociaux</option>
                          <option value="bouche" data-id="element-408">Bouche à oreille</option>
                          <option value="radio" data-id="element-409">Radio</option>
                          <option value="affiche" data-id="element-410">Affiche / Flyer</option>
                          <option value="autre" data-id="element-411">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-412">
                        <label className={labelClass} data-id="element-413">
                          Vos motivations (facultatif)
                        </label>
                        <textarea name="motivations" rows={3} className={inputClass + ' resize-none'} placeholder="Pourquoi souhaitez-vous suivre cette formation ?" data-id="element-414"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Festival */}
                  {activeModal === 'festival' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-415">
                      <div className="space-y-2" data-id="element-416">
                        <label className={labelClass} data-id="element-417">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-418" />
                      </div>
                      <div className="space-y-2" data-id="element-419">
                        <label className={labelClass} data-id="element-420">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-421" />
                      </div>
                      <div className="space-y-2" data-id="element-422">
                        <label className={labelClass} data-id="element-423">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-424" />
                      </div>
                      <div className="space-y-2" data-id="element-425">
                        <label className={labelClass} data-id="element-426">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-427" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-428">
                        <label className={labelClass} data-id="element-429">Vous êtes *</label>
                        <select name="profil" required className={selectClass} data-id="element-430">
                          <option value="" data-id="element-431">Sélectionner...</option>
                          <option value="personnel" data-id="element-432">Personnel de maison</option>
                          <option value="employeur" data-id="element-433">Employeur</option>
                          <option value="partenaire" data-id="element-434">
                            Partenaire / Institution
                          </option>
                          <option value="media" data-id="element-435">Média / Presse</option>
                          <option value="autre" data-id="element-436">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-437">
                        <label className={labelClass} data-id="element-438">
                          Participation souhaitée
                        </label>
                        <select name="participation" className={selectClass} data-id="element-439">
                          <option value="" data-id="element-440">Sélectionner...</option>
                          <option value="visiteur" data-id="element-441">Visiteur</option>
                          <option value="exposant" data-id="element-442">Exposant / Stand</option>
                          <option value="temoin" data-id="element-443">Témoignage</option>
                          <option value="recruteur" data-id="element-444">Espace recrutement</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-445">
                        <label className={labelClass} data-id="element-446">
                          Message (facultatif)
                        </label>
                        <textarea name="message" rows={3} className={inputClass + ' resize-none'} placeholder="Informations complémentaires..." data-id="element-447"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Employeur Partenaire */}
                  {activeModal === 'employeur' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-448">
                      <div className="space-y-2" data-id="element-449">
                        <label className={labelClass} data-id="element-450">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-451" />
                      </div>
                      <div className="space-y-2" data-id="element-452">
                        <label className={labelClass} data-id="element-453">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-454" />
                      </div>
                      <div className="space-y-2" data-id="element-455">
                        <label className={labelClass} data-id="element-456">Type d'employeur *</label>
                        <select name="typeEmployeur" required className={selectClass} data-id="element-457">
                          <option value="" data-id="element-458">Sélectionner...</option>
                          <option value="famille" data-id="element-459">Famille / Particulier</option>
                          <option value="entreprise" data-id="element-460">Entreprise</option>
                          <option value="institution" data-id="element-461">Institution / ONG</option>
                          <option value="hotel" data-id="element-462">Hôtel / Restaurant</option>
                          <option value="autre" data-id="element-463">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-464">
                        <label className={labelClass} data-id="element-465">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-466" />
                      </div>
                      <div className="space-y-2" data-id="element-467">
                        <label className={labelClass} data-id="element-468">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-469" />
                      </div>
                      <div className="space-y-2" data-id="element-470">
                        <label className={labelClass} data-id="element-471">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-472" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-473">
                        <label className={labelClass} data-id="element-474">Profils recherchés</label>
                        <select name="profilsRecherches" className={selectClass} data-id="element-475">
                          <option value="" data-id="element-476">Sélectionner...</option>
                          <option value="menage" data-id="element-477">Personnel d'entretien</option>
                          <option value="cuisine" data-id="element-478">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-479">Garde d'enfants</option>
                          <option value="gardien" data-id="element-480">
                            Gardien / Agent de sécurité
                          </option>
                          <option value="chauffeur" data-id="element-481">Chauffeur</option>
                          <option value="polyvalent" data-id="element-482">Polyvalent</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-483">
                        <label className={labelClass} data-id="element-484">
                          Vos attentes (facultatif)
                        </label>
                        <textarea name="attentes" rows={3} className={inputClass + ' resize-none'} placeholder="Décrivez vos besoins et attentes..." data-id="element-485"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Recruter */}
                  {activeModal === 'recruter' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-486">
                      <div className="space-y-2" data-id="element-487">
                        <label className={labelClass} data-id="element-488">Nom complet *</label>
                        <input name="nom" type="text" required className={inputClass} placeholder="Votre nom" data-id="element-489" />
                      </div>
                      <div className="space-y-2" data-id="element-490">
                        <label className={labelClass} data-id="element-491">Prénom *</label>
                        <input name="prenom" type="text" required className={inputClass} placeholder="Votre prénom" data-id="element-492" />
                      </div>
                      <div className="space-y-2" data-id="element-493">
                        <label className={labelClass} data-id="element-494">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-495" />
                      </div>
                      <div className="space-y-2" data-id="element-496">
                        <label className={labelClass} data-id="element-497">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-498" />
                      </div>
                      <div className="space-y-2" data-id="element-499">
                        <label className={labelClass} data-id="element-500">Ville *</label>
                        <input name="ville" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-501" />
                      </div>
                      <div className="space-y-2" data-id="element-502">
                        <label className={labelClass} data-id="element-503">Quartier</label>
                        <input name="quartier" type="text" className={inputClass} placeholder="Ex: Haie Vive" data-id="element-504" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-505">
                        <label className={labelClass} data-id="element-506">
                          Type de personnel recherché *
                        </label>
                        <select name="typePersonnel" required className={selectClass} data-id="element-507">
                          <option value="" data-id="element-508">Sélectionner...</option>
                          <option value="menage" data-id="element-509">
                            Personnel d'entretien ménager
                          </option>
                          <option value="cuisine" data-id="element-510">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-511">
                            Garde d'enfants / Nounou
                          </option>
                          <option value="gardien" data-id="element-512">Gardien</option>
                          <option value="chauffeur" data-id="element-513">Chauffeur</option>
                          <option value="maintenance" data-id="element-514">
                            Agent de maintenance
                          </option>
                          <option value="polyvalent" data-id="element-515">
                            Personnel polyvalent
                          </option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-516">
                        <label className={labelClass} data-id="element-517">
                          Type de contrat souhaité
                        </label>
                        <select name="typeContrat" className={selectClass} data-id="element-518">
                          <option value="" data-id="element-519">Sélectionner...</option>
                          <option value="temps_plein" data-id="element-520">
                            Temps plein (logé ou non)
                          </option>
                          <option value="temps_partiel" data-id="element-521">Temps partiel</option>
                          <option value="ponctuel" data-id="element-522">
                            Intervention ponctuelle
                          </option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-523">
                        <label className={labelClass} data-id="element-524">
                          Date de début souhaitée
                        </label>
                        <input name="dateDebut" type="date" className={inputClass} data-id="element-525" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-526">
                        <label className={labelClass} data-id="element-527">
                          Description du poste et attentes *
                        </label>
                        <textarea name="description" rows={4} required className={inputClass + ' resize-none'} placeholder="Décrivez les tâches, horaires, conditions..." data-id="element-528"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Partenariat */}
                  {activeModal === 'partenariat' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-529">
                      <div className="space-y-2" data-id="element-530">
                        <label className={labelClass} data-id="element-531">
                          Nom de l'organisation *
                        </label>
                        <input name="organisation" type="text" required className={inputClass} placeholder="Nom de votre structure" data-id="element-532" />
                      </div>
                      <div className="space-y-2" data-id="element-533">
                        <label className={labelClass} data-id="element-534">
                          Type d'organisation *
                        </label>
                        <select name="typeOrganisation" required className={selectClass} data-id="element-535">
                          <option value="" data-id="element-536">Sélectionner...</option>
                          <option value="entreprise" data-id="element-537">Entreprise privée</option>
                          <option value="ong" data-id="element-538">ONG / Association</option>
                          <option value="institution" data-id="element-539">
                            Institution publique
                          </option>
                          <option value="fondation" data-id="element-540">Fondation</option>
                          <option value="media" data-id="element-541">Média</option>
                          <option value="autre" data-id="element-542">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-543">
                        <label className={labelClass} data-id="element-544">Nom du contact *</label>
                        <input name="nomContact" type="text" required className={inputClass} placeholder="Votre nom complet" data-id="element-545" />
                      </div>
                      <div className="space-y-2" data-id="element-546">
                        <label className={labelClass} data-id="element-547">Fonction *</label>
                        <input name="fonction" type="text" required className={inputClass} placeholder="Votre poste" data-id="element-548" />
                      </div>
                      <div className="space-y-2" data-id="element-549">
                        <label className={labelClass} data-id="element-550">Téléphone *</label>
                        <input name="telephone" type="tel" required className={inputClass} placeholder="+229..." data-id="element-551" />
                      </div>
                      <div className="space-y-2" data-id="element-552">
                        <label className={labelClass} data-id="element-553">Email *</label>
                        <input name="email" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-554" />
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-555">
                        <label className={labelClass} data-id="element-556">
                          Type de partenariat envisagé
                        </label>
                        <select name="typePartenariat" className={selectClass} data-id="element-557">
                          <option value="" data-id="element-558">Sélectionner...</option>
                          <option value="financier" data-id="element-559">Soutien financier</option>
                          <option value="technique" data-id="element-560">Appui technique</option>
                          <option value="formation" data-id="element-561">
                            Co-animation de formations
                          </option>
                          <option value="emploi" data-id="element-562">
                            Offres d'emploi / Recrutement
                          </option>
                          <option value="communication" data-id="element-563">
                            Visibilité / Communication
                          </option>
                          <option value="autre" data-id="element-564">Autre</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-565">
                        <label className={labelClass} data-id="element-566">
                          Description de votre proposition *
                        </label>
                        <textarea name="proposition" rows={4} required className={inputClass + ' resize-none'} placeholder="Décrivez votre proposition de partenariat..." data-id="element-567"></textarea>
                      </div>
                    </div>}

                  {/* Formulaire Recyclage */}
                  {activeModal === 'recyclage' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-568">
                      <div className="space-y-2 md:col-span-2 bg-teal-50 p-4 rounded-lg border border-teal-200" data-id="element-569">
                        <h4 className="font-semibold text-teal-800 flex items-center gap-2" data-id="element-570">
                          <RefreshCw className="w-5 h-5" data-id="element-571" />
                          Informations sur l'employeur
                        </h4>
                      </div>
                      <div className="space-y-2" data-id="element-572">
                        <label className={labelClass} data-id="element-573">
                          Votre nom complet *
                        </label>
                        <input name="nomEmployeur" type="text" required className={inputClass} placeholder="Nom de l'employeur" data-id="element-574" />
                      </div>
                      <div className="space-y-2" data-id="element-575">
                        <label className={labelClass} data-id="element-576">Téléphone *</label>
                        <input name="telephoneEmployeur" type="tel" required className={inputClass} placeholder="+229..." data-id="element-577" />
                      </div>
                      <div className="space-y-2" data-id="element-578">
                        <label className={labelClass} data-id="element-579">Email *</label>
                        <input name="emailEmployeur" type="email" required className={inputClass} placeholder="exemple@email.com" data-id="element-580" />
                      </div>
                      <div className="space-y-2" data-id="element-581">
                        <label className={labelClass} data-id="element-582">Ville *</label>
                        <input name="villeEmployeur" type="text" required className={inputClass} placeholder="Ex: Cotonou" data-id="element-583" />
                      </div>

                      <div className="space-y-2 md:col-span-2 bg-blue-50 p-4 rounded-lg border border-blue-200 mt-4" data-id="element-584">
                        <h4 className="font-semibold text-blue-800 flex items-center gap-2" data-id="element-585">
                          <Users className="w-5 h-5" data-id="element-586" />
                          Informations sur l'employé à recycler
                        </h4>
                      </div>
                      <div className="space-y-2" data-id="element-587">
                        <label className={labelClass} data-id="element-588">Nom de l'employé *</label>
                        <input name="nomEmploye" type="text" required className={inputClass} placeholder="Nom complet de l'employé" data-id="element-589" />
                      </div>
                      <div className="space-y-2" data-id="element-590">
                        <label className={labelClass} data-id="element-591">Poste actuel *</label>
                        <select name="posteActuel" required className={selectClass} data-id="element-592">
                          <option value="" data-id="element-593">Sélectionner...</option>
                          <option value="menage" data-id="element-594">Personnel d'entretien</option>
                          <option value="cuisine" data-id="element-595">Cuisinier(ère)</option>
                          <option value="garde" data-id="element-596">Garde d'enfants</option>
                          <option value="gardien" data-id="element-597">Gardien</option>
                          <option value="chauffeur" data-id="element-598">Chauffeur</option>
                          <option value="polyvalent" data-id="element-599">Polyvalent</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-600">
                        <label className={labelClass} data-id="element-601">
                          Ancienneté chez vous
                        </label>
                        <select name="anciennete" className={selectClass} data-id="element-602">
                          <option value="" data-id="element-603">Sélectionner...</option>
                          <option value="moins_1" data-id="element-604">Moins d'1 an</option>
                          <option value="1_3" data-id="element-605">1 à 3 ans</option>
                          <option value="3_5" data-id="element-606">3 à 5 ans</option>
                          <option value="plus_5" data-id="element-607">Plus de 5 ans</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-608">
                        <label className={labelClass} data-id="element-609">
                          Téléphone de l'employé
                        </label>
                        <input name="telephoneEmploye" type="tel" className={inputClass} placeholder="+229..." data-id="element-610" />
                      </div>

                      <div className="space-y-2 md:col-span-2 bg-amber-50 p-4 rounded-lg border border-amber-200 mt-4" data-id="element-611">
                        <h4 className="font-semibold text-amber-800 flex items-center gap-2" data-id="element-612">
                          <GraduationCap className="w-5 h-5" data-id="element-613" />
                          Formation de recyclage souhaitée
                        </h4>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-614">
                        <label className={labelClass} data-id="element-615">
                          Points de formation souhaités *
                        </label>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2" data-id="element-616">
                          {["Techniques d'entretien avancées", 'Hygiène et sécurité', 'Communication et savoir-être', 'Gestion du temps et organisation', 'Cuisine et nutrition', "Garde d'enfants et pédagogie", 'Maintenance et petites réparations', 'Premiers secours'].map((item, i) => <label key={i} className="flex items-center gap-2 p-2 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer" data-id="element-617">
                              <input name="pointsFormation" type="checkbox" value={item} className="w-4 h-4 text-[#1E88E5] rounded" data-id="element-618" />
                              <span className="text-sm text-gray-700" data-id="element-619">
                                {item}
                              </span>
                            </label>)}
                        </div>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-620">
                        <label className={labelClass} data-id="element-621">
                          Autres points de formation (précisez)
                        </label>
                        <input name="autresPoints" type="text" className={inputClass} placeholder="Autres compétences à développer..." data-id="element-622" />
                      </div>
                      <div className="space-y-2" data-id="element-623">
                        <label className={labelClass} data-id="element-624">
                          Période souhaitée *
                        </label>
                        <select name="periodeSouhaitee" required className={selectClass} data-id="element-625">
                          <option value="" data-id="element-626">Sélectionner...</option>
                          <option value="urgent" data-id="element-627">Dès que possible</option>
                          <option value="1mois" data-id="element-628">Dans le mois</option>
                          <option value="3mois" data-id="element-629">
                            Dans les 3 prochains mois
                          </option>
                          <option value="flexible" data-id="element-630">Flexible</option>
                        </select>
                      </div>
                      <div className="space-y-2" data-id="element-631">
                        <label className={labelClass} data-id="element-632">
                          Durée de formation souhaitée
                        </label>
                        <select name="dureeSouhaitee" className={selectClass} data-id="element-633">
                          <option value="" data-id="element-634">Sélectionner...</option>
                          <option value="1jour" data-id="element-635">1 journée</option>
                          <option value="2_3jours" data-id="element-636">2-3 jours</option>
                          <option value="1semaine" data-id="element-637">1 semaine</option>
                          <option value="flexible" data-id="element-638">À définir ensemble</option>
                        </select>
                      </div>
                      <div className="space-y-2 md:col-span-2" data-id="element-639">
                        <label className={labelClass} data-id="element-640">
                          Observations complémentaires
                        </label>
                        <textarea name="observations" rows={3} className={inputClass + ' resize-none'} placeholder="Points particuliers à signaler, difficultés observées..." data-id="element-641"></textarea>
                      </div>
                    </div>}

                  <div className="pt-4 border-t border-gray-100 flex justify-end gap-4" data-id="element-642">
                    <Button type="button" variant="ghost" onClick={closeModal} data-id="element-643">
                      Annuler
                    </Button>
                    <Button type="submit" disabled={isSubmitting} className="min-w-[200px]" data-id="element-644">
                      {isSubmitting ? <>
                          <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-645" />
                          Envoi en cours...
                        </> : 'Soumettre'}
                    </Button>
                  </div>
                </form>}
            </div>
          </div>
        </div>}
    </Layout>;
}